import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {catchError, EMPTY, first, forkJoin, Observable, of, map, tap} from 'rxjs';
import {NotificationType} from '../enum/notification.enum';
import {Club} from '../models';
import {ClubService, DefaultNotificationService, StorageService} from '../services';
import {ClubTranslationsService} from 'src/app/shared/translations';

/**
 * Checks whether the user still has a valid token.
 */
@Injectable()
export class ClubSelectedResolver implements OnDestroy {

  constructor(
    private clubService: ClubService,
    private router: Router,
    private storage: StorageService,
    private notificationService: DefaultNotificationService,
    private clubTranslations: ClubTranslationsService
  ) {
  }

  public ngOnDestroy(): void {
  }

  /**
   * Checks whether the user has selected a club-overview.
   */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    if (this.storage.selectedClub.value === null) {

      const calls: Array<undefined | Observable<any>> = [
        this.clubService.getClubById(route.params['id']).pipe(first(), catchError(error => this.handleError(error)), tap(res => {
          if (res.status === 'in_deletion') {
            this.handleError({error: {status: 404}});
          }
        })),
        this.clubService.getModules(route.params['id']).pipe(first(), catchError(error => this.handleError(error))),
      ];

      return forkJoin(calls).pipe(map(results => {
        if (results) {
          const club: Club = results[0];
          club.modules = results[1];
          this.storage.updateSelectedClub(club);
          return of(club);
        } else {
          this.router.navigate(['/manage/clubs']);
          return EMPTY;
        }
      }));
    }
  }

  private handleError(error?) {
    if (error.status === 404) {
      this.notificationService.showNotification({
        type: NotificationType.ALERT,
        message: this.clubTranslations.i18nErrorClubNotExisting
      });
      this.router.navigate(['/manage/clubs']);
      return EMPTY;
    }
    if (error.status === 403) {
      this.notificationService.showNotification({
        type: NotificationType.WARNING,
        message: this.clubTranslations.i18nWarningClubNoAccess
      });
      this.router.navigate(['/manage/clubs']);
      return EMPTY;
    }
    this.router.navigate(['/manage/clubs']);
    return EMPTY;
  }
}
